import { Component, Input } from '@angular/core';

@Component({
  selector: 'rnpl-grid-table-accordion',
  templateUrl: './grid-table-accordion.component.html',
  styleUrls: ['./grid-table-accordion.component.scss'],
})
export class GridTableAccordionComponent {

  @Input() title: string;

  public expanded: boolean = true;

  constructor() {
  }

}
